<style>
    .c-request {
        position: relative;
    }
</style>
<template>
    <div class="c-request">
        <div class="animated fadeIn">
            <slot name="body"></slot>
        </div>
        <Block class="the-block-block" :img="options.blockImg" :transparent="options.blockTransparent" v-if="dataProcessing && (options.blockOnProcessing == undefined || options.blockOnProcessing)" :spinner="options.blockSpinner"></Block>
        <Alert class="mt-3" :alert="dataAlert"></Alert>
    </div>
</template>

<script>
    import Axios from 'axios'
    import Block from './Block'
    import Alert from './Alert'

    const cancelToken = Axios.CancelToken

    export default {
        name: 'Request',
        components: {
            Block,
            Alert
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        showAlert: true,
                        blockOnProcessing: true,
                        blockTransparent: false,
                        blockImg: '',
                        blockSpinner: 'wave'
                    }
                }
            },
            url: {
                type: String,
                default: ''
            },
            root: {
                type: String,
                default: ''
            },
            method: {
                type: String,
                default: 'GET'
            },
            onRequestSuccess: {
                type: Function,
                default: function() {
                    return false
                }
            },
            onRequestError: {
                type: Function,
                default: function() {
                    return false
                }
            },
            requestConfigs: {
                type: Object,
                default: function() {
                    return {}
                }
            }
        },
        data: () => {
            return {
                dataUrl: Mantle.Config.api.url,
                dataRoot: '',
                dataMethod: '',
                dataProcessing: false,
                dataExecutor: false,
                dataArgs: [],
                dataAlert: {}
            }
        },
        mounted() {
            if (this.url !== '') {
                this.dataUrl = this.url
            }
            this.dataRoot = this.root
            this.dataMethod = this.method
            this.$emit('onInit')
        },
        methods: {
            setRoot(root) {
                this.dataRoot = root
            },
            setMethod(method) {
                this.dataMethod = method
            },
            getMethod() {
                return this.dataMethod
            },
            addArg(key, value, type) {
                if (type===undefined) {
                    type = Core.Value.typeText
                }

                let argIndex = Core.Array.findIndexByKey(this.dataArgs, 'key', key)
                if (argIndex!==false) {
                    this.dataArgs[argIndex] = {
                        key: key,
                        value: value,
                        type: type
                    }
                } else {
                    this.dataArgs.push(
                        {
                            key: key,
                            value: value,
                            type: type
                        }
                    )
                }
            },
            getArg(key) {
                let arg = Core.Array.findByKey(this.dataArgs, 'key', key)
                return arg;
            },
            removeArg(key) {
                let args = Core.Array.removeByKey(this.dataArgs, 'key', key)
                if (args) {
                    this.dataArgs = args
                }
            },
            clearArgs() {
                this.dataArgs = []
            },
            request() {
                let me = this

                this.dataAlert.show = false
                this.dataProcessing = true

                let method = this.dataMethod

                let requestConfigs = Core.Request.getConfigs(Mantle.Config.api.auth.token, Mantle.Config.api.auth.signature, Core.Session.AuthUser.email, Core.Session.AuthUser.signature, Core.Session.subDomain, Core.Session.environmentId, Core.Session.branchId, Core.Session.Setting.getSetting('lang'), Core.Session.domain)
                if (Object.keys(this.requestConfigs).length>0){
                    requestConfigs = this.requestConfigs
                } else {
                    requestConfigs.cancelToken = new cancelToken(function executor(c) {
                        me.dataCancel = c
                    })
                }

                switch(method) {
                    case Core.Request.methodGet:
                        Axios.get(Core.Request.get(this.dataUrl, this.dataRoot, this.dataArgs), requestConfigs)
                            .then(function (response) {
                                if (response.data !== undefined) {
                                    me.success(response.data)
                                }
                            }).catch(function(err){
                            me.error(err)
                        })
                        break
                    case Core.Request.methodPost:

                        let postParams = Core.Request.buildParams(this.dataArgs)
                        if (requestConfigs['Content-Type']!==undefined) {
                            switch(requestConfigs['Content-Type']) {
                                case 'application/json':
                                    postParams = Core.Request.buildJSONParams(this.dataArgs)
                                    break
                            }
                        }

                        Axios.post(Core.Request.get(this.dataUrl, this.dataRoot), postParams, requestConfigs)
                            .then(function (response) {
                                if (response.data !== undefined) {
                                    me.success(response.data)
                                }
                            }).catch(function(err){
                            me.error(err)
                        })
                        break
                    case Core.Request.methodPut:

                        let putParams = Core.Request.buildParams(this.dataArgs)
                        if (requestConfigs['Content-Type']!==undefined) {
                            switch(requestConfigs['Content-Type']) {
                                case 'application/json':
                                    putParams = Core.Request.buildJSONParams(this.dataArgs)
                                    break
                            }
                        }

                        Axios.put(Core.Request.get(this.dataUrl, this.dataRoot), putParams, requestConfigs)
                            .then(function (response) {
                                if (response.data !== undefined) {
                                    me.success(response.data)
                                }
                            }).catch(function(err){
                            me.error(err)
                        })
                        break
                    case Core.Request.methodDelete:
                        Axios.delete(Core.Request.get(this.dataUrl, this.dataRoot, this.dataArgs), requestConfigs)
                            .then(function (response) {
                                me.success(response.data)
                            }).catch(function(err){
                            me.error(err)
                        })
                        break
                }
            },
            success(data) {
                if (data.alert!==undefined && (this.options.showAlert||this.options.showAlert===undefined)) {
                    this.dataAlert = data.alert
                }
                if (data.session !== undefined) {
                    Core.Session.set(data.session)
                }
                this.onRequestSuccess(data)
                this.$emit('onRequestSuccess', data)
                this.dataProcessing = false
            },
            error(data) {
                this.onRequestError(data)
                this.dataProcessing = false
            },
            cancel() {
                if (false !== this.dataExecutor) {
                    this.dataExecutor('Cancel previous')
                }
            }
        }
    }
</script>
